export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: '50a4023c-08dd-439d-aa98-9cc3f4275d6e',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access 50a4023c-08dd-439d-aa98-9cc3f4275d6e'],
        uri: 'https://pplfirstprod.onmicrosoft.com/50a4023c-08dd-439d-aa98-9cc3f4275d6e/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
            mfa: 'B2C_1A_STEPUP_MFA'
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplathomeb2c.pplfirst.com/pplfirstprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            },
            mfa: {
                authority: 'https://pplathomeb2c.pplfirst.com/pplfirstprod.onmicrosoft.com/B2C_1A_STEPUP_MFA',
            }
        },
        authorityDomain: 'pplathomeb2c.pplfirst.com',
    },
    apiUrl: 'https://ngenapiext-prd.pplfirst.com/external',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://wotc.com/portal/public-partnerships-home-care-llc/f8850?noStartDate=1',
    apimSubScriptionKey: '235e2f643ae249dda59641ccca346bf8',
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    mfaTimeOutSeconds: 600
};